// 禁止双指方法
document.addEventListener('touchstart', function(event) {
  if (event.touches.length > 1) {
    event.preventDefault()
  }
}, false)
// 禁止双击放大
var lastToucheEnd = 0
document.addEventListener('touchend', function(event) {
  var now = Date.now()
  if (now - lastToucheEnd <= 300) {
    event.preventDefault()
  }
  lastToucheEnd = now
}, false)

document.addEventListener('gesturestart', function(event) {
  event.preventDefault()
}, false)

document.addEventListener('dblclick', function(event) {
  event.preventDefault()
}, false)



// WEBPACK FOOTER //
// ./src/assets/js/noScale.js